module.exports = __webpack_public_path__ + "img/philia-contactanos.3d48cc79.jpg";